// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-details-price-breakup .order-details-border-top[data-v-47ab5f77]{border-top:1px solid #e1e1e1}.order-details-price-breakup .yellow-bg[data-v-47ab5f77]{background-color:#fffce2}.order-details-price-breakup .blue-bg[data-v-47ab5f77]{background-color:#e2fdff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
